import { produce } from 'immer'
import { AdsState } from './AdsState'
import { AdsType } from './AdsType'
import { GlobalType } from '../Global'
export const initialAdsState: AdsState = {
  interstialCounter: 0,
  rewardCounter: 0,
  iFrequency: 5,
  rFrequency: 30,
  lastViewAt: undefined
}

export const adsReducer = (state = initialAdsState, action: Action) =>
  produce(state, draft => {
    switch (action.type) {
      case AdsType.RESET_REWARD:
        draft.lastViewAt = new Date().toISOString()
        draft.rewardCounter = 0
        draft.interstialCounter = 0
        return
      case AdsType.RESET_INTERSTITIAL:
        draft.lastViewAt = new Date().toISOString()
        draft.interstialCounter = 0
        return
      case AdsType.INCREMENT_COUNTER:
        draft.interstialCounter += 1
        draft.rewardCounter += 1
        return
      case AdsType.SET_DEFAULT_VALUE:
        draft.iFrequency = action.payload.iFrequency
        draft.rFrequency = action.payload.rFrequency
        return

      case GlobalType.CLEAR_LOADED_DATA:
        return { ...initialAdsState }
    }
  })

type Action =
  | { type: GlobalType.CLEAR_LOADED_DATA }
  | { type: AdsType.INCREMENT_COUNTER }
  | { type: AdsType.RESET_INTERSTITIAL }
  | { type: AdsType.RESET_REWARD }
  | { type: AdsType.SET_DEFAULT_VALUE; payload: { iFrequency: number; rFrequency: number } }
